/* @ts-ignore */
/**
 * Created by PanJiaChen on 16/11/18.
 */
import { UserModule } from '@/store/modules/user'
// @ts-ignore
import html2pdf from 'html2pdf.js'
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time: string | number | Date, cFormat: string) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  // eslint-disable-next-line camelcase
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result: { length: number; }, key: string) => {
    // @ts-ignore
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  // eslint-disable-next-line camelcase
  return time_str
}
/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time: string | number | Date, option: any) {
  if (('' + time).length === 10) {
    // @ts-ignore
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  // @ts-ignore
  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}
/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url: { split: (arg0: string) => any[]; }) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  )
}

/**
 * 存储localStorage
 */
export const setStore = (name: string, content: any) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = (name: string) => {
  if (!name) return
  if (typeof name !== 'string') {
    // @ts-ignore
    return JSON.parse(window.localStorage.getItem(name))
  } else {
    return window.localStorage.getItem(name)
  }
}

/**
 * 存储sessionStorage
 */
export const setSessionStore = (name: string, content: any) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}

/**
 * 获取sessionStorage
 */
export const getSessionStore = (name: string) => {
  if (!name) return
  if (typeof name !== 'string') {
    // @ts-ignore
    return JSON.parse(window.sessionStorage.getItem(name))
  } else {
    return window.sessionStorage.getItem(name)
  }
}

export function formatDate(timeStamp: string | number | Date, hourFlag = false, joiner = '-') {
  var time = new Date(timeStamp)
  var year = time.getFullYear()
  var month = time.getMonth() + 1
  var date = time.getDate()
  var hour = time.getHours()
  var minute = time.getMinutes()
  return hourFlag
    ? year +
    joiner +
    (month < 10 ? '0' + month : month) +
    joiner +
    (date < 10 ? '0' + date : date) +
    ' ' +
    (hour < 10 ? '0' + hour : hour) +
    ':' +
    (minute < 10 ? '0' + minute : minute)
    : year +
    joiner +
    (month < 10 ? '0' + month : month) +
    joiner +
    (date < 10 ? '0' + date : date)
}

// 将网络图片转换成Base64
// url为图片的url
export function toBase64(url:string) {
  return new Promise(resolve => {
    window.URL = window.URL || window.webkitURL
    let xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = function() {
      if (this.status === 200 && this.readyState === 4) {
        let blob = this.response
        let reader = new FileReader()
        reader.onloadend = function(e) {
          // @ts-ignore
          resolve(e.target.result)
        }
        reader.readAsDataURL(blob)
      }
    }
    xhr.send()
  })
}

/**
 * 深拷贝 【这种方法能正确处理的对象只有 Number, String, Boolean, Array, 扁平对象，即那些能够被 json 直接表示的数据结构】
 * @param object
 */
export function deepClone(object:any) {
  return JSON.parse(JSON.stringify(object))
}

/**
 * 下载
 * @param  {String} url 目标文件地址
 * @param  {String} filename 想要保存的文件名称
 */
export function downloadFile(url:string, filename:string, callback:any) {
  /**
   * 获取 blob
   * @param  {String} url 目标文件地址
   * @return {Promise}
   */
  function getBlob(url:string) {
    return new Promise(resolve => {
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.responseType = 'blob'
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(xhr.response)
        }
      }
      xhr.send()
    })
  }

  /**
   * 保存
   * @param  {Blob} blob
   * @param  {String} filename 想要保存的文件名称
   */
  function saveAs(blob:any, filename:string) {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename)
    } else {
      const link = document.createElement('a')
      const body:any = document.querySelector('body')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      // fix Firefox
      link.style.display = 'none'
      body.appendChild(link)
      link.click()
      body.removeChild(link)

      window.URL.revokeObjectURL(link.href)
    }
    if (callback) {
      callback()
    }
  }

  getBlob(url).then(blob => {
    saveAs(blob, filename)
  })
}

export const turnTimeStamp = (timeStamp: number) => {
  const newDate = new Date()
  newDate.setTime(timeStamp)
  return newDate
}

// 获取文件大小
export const getFileSize = (limit: number) => {
  var size = ''
  if (limit < 0.1 * 1024) {
    // 如果小于0.1KB转化成B
    size = limit.toFixed(2) + 'B'
  } else if (limit < 0.1 * 1024 * 1024) {
    // 如果小于0.1MB转化成KB
    size = (limit / 1024).toFixed(2) + 'KB'
  } else if (limit < 0.1 * 1024 * 1024 * 1024) {
    // 如果小于0.1GB转化成MB
    size = (limit / (1024 * 1024)).toFixed(2) + 'MB'
  } else {
    // 其他转化成GB
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
  }

  var sizestr = size + ''
  var len = sizestr.indexOf('.')
  var dec = sizestr.substr(len + 1, 2)
  if (dec === '00') {
    // 当小数点后为00时 去掉小数部分
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
}

export const httpHtml = (text:string) => {
  // eslint-disable-next-line no-useless-escape
  var reg = /([\w\-_]+(\.[a-z]+)+([\w\-\.@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?)/g

  // var reg = /(((http|ftp|https):\/\/)?[\w\-_]+(\.[\w\-_]+)+([\w\-\.@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?)/g
  // var reg = /((http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?)/g
  return text
    .replace(/\n/g, '<br>')
    .replace(/\s/g, '&nbsp')
    .replace(
      reg,
      "<a href='//$1' target='_blank' style='text-decoration:underline;color:#0FB589'>$1</a>"
    )
}

export const getParam = (paramName:string) => {
  var url = window.document.location.href.toString()
  var u = url.split('?')
  var arr:any = []
  if (typeof u[1] === 'string') {
    u = u[1].split('&')
    for (var i in u) {
      var a = u[i].split('=')
      arr[a[0]] = a[1]
    }
  }

  for (const a in arr) {
    if (a === paramName) {
      return arr[a]
    }
  }
}

/**
 * 生成唯随机字符串
 * @param length
 */
export function randomString(length: number) {
  const len = length || 32
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  const maxPos = chars.length
  let randomStr = ''
  for (let i = 0; i < len; i++) {
    randomStr += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return randomStr
}

/**
 * 倒计时
 * @param timeStamp
 * @param sysTime {int} 系统时间 如不传则取当前用户时间
 */
export function countDownTime(timeStamp:number, sysTime: number) {
  let str = ''
  const now = sysTime || new Date().getTime()
  // let endDate = new Date(timeStamp);
  // let leftTime = new Date('2019/01/25 09:00:00').getTime() - now
  const leftTime:number = timeStamp - now
  if (leftTime > 0) {
    // @ts-ignore
    const leftSecond:any = parseInt(leftTime / 1000)
    const day1:any = Math.floor(leftSecond / (60 * 60 * 24))
    let hour:any = Math.floor((leftSecond - day1 * 24 * 60 * 60) / 3600)
    let minute:any = Math.floor(
      (leftSecond - day1 * 24 * 60 * 60 - hour * 3600) / 60
    )
    let second:any = Math.floor(
      leftSecond - day1 * 24 * 60 * 60 - hour * 3600 - minute * 60
    )
    // if (day1 < 10) {
    //   day1 = '0' + day1;
    // }
    if (hour < 10) {
      hour = '0' + hour
    }
    if (minute < 10) {
      minute = '0' + minute
    }
    if (second < 10) {
      second = '0' + second
    }
    const dayStr = day1 > 0 ? day1 + '天' : ''
    // let hStr = hour > 0 ? hour + ':' : ''
    // let mStr = minute > 0 ? minute + ':' : ''
    // let sStr = second > 0 ? second : ''
    str = dayStr + ' ' + hour + ':' + minute + ':' + second
  }
  return str
}

// @ts-ignore
export function accMul(arg1, arg2) {
  let m = 0
  const s1 = arg1.toString()
  const s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
    // eslint-disable-next-line no-empty
  } catch (e) {}
  try {
    m += s2.split('.')[1].length
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  )
}
//

/**
 * @description: 获取唯一ID
 * @param {type}
 * @return: 唯一ID
 */
export function _guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
// 去重 数值数组
// @ts-ignore
export function uniqueNumberArr(arr) {
  // return [...new Set(arr)]
  var newArr = []
  for (var i in arr) {
    if (newArr.indexOf(arr[i]) === -1) {
      newArr.push(arr[i])
    }
  }
  return newArr
}
/**
 * 去重 对象数组
 * @param arr 对象数组
 * @param key 指定key
 */
// @ts-ignore
export function uniqueObjectArr(arr, key) {
  const n = {} // hash表
  const r = [] // 临时数组
  for (let i = 0; i < arr.length; i++) {
    // @ts-ignore
    if (!n[arr[i][key]]) {
      // @ts-ignore
      n[arr[i][key]] = true // 存入hash表
      r.push(arr[i]) // 把当前数组的当前项push到临时数组里面
    }
  }
  return r
}

// 赋值
// @ts-ignore
export function setVal(post, data) {
  for (const i in post) {
    for (const a in data) {
      if (i === a) {
        post[i] = data[a]
      }
    }
  }
}
// 对象重置
export function resetObject(obj:{}, exclude: [string]) {
  console.log(obj)
  for (let key in obj) {
    // console.log(key)
    // @ts-ignore
    if (exclude && exclude.includes(key)) {
      // return
    } else {
      if ((obj as any)[key] instanceof Array) {
        // 数组
        (obj as any)[key] = []
      } else if ((obj as any)[key] instanceof Object) {
        // 对象
        resetObject((obj as any)[key], exclude)
      } else if ((obj as any)[key] === null || (obj as any)[key] === undefined) {
        (obj as any)[key] = null
      } else if ((obj as any) instanceof RegExp) {
        (obj as any)[key] = new RegExp((obj as any)[key])
      } else if ((obj as any) instanceof Date) {
        (obj as any)[key] = new Date((obj as any)[key])
      } else {
        (obj as any)[key] = ''
      }
    }
  }
  return obj
}

export function parsePrice(price:number) {
  // @ts-ignore
  return parseInt((Math.floor(price * 100) / 100) * 100)
}

// 防抖
export function debounce(fn:any, delay:number) {
  let timer:any = null
  return function() {
    let arg = arguments
    clearTimeout(timer)
    timer = setTimeout(() => {
      // @ts-ignore
      fn.apply(this, arg)
    }, delay)
  }
}

// 判断是否为详情页
export function isDetail(fullPath: string) {
  let arr = fullPath.split('/')
  let length = arr.length
  let arr2 = arr[length - 1].split('?')
  return arr2[0] === 'detail'
}
// 判断是否为详情页
export function hasPermission(value: number) {
  // @ts-ignore
  const codes = UserModule.accesses.map(item => parseInt(item.code))
  if (value) {
    return codes.includes(value)
  } else {
    throw new Error('need code!')
  }
}

export const savePdf = (htm:any, name:string, callback:Function) => {
  var element = document.getElementById(htm)
  html2pdf(element, {
    margin: [0, 0.4, 0, 0.4],
    filename: name + '.pdf',
    image: {
      type: 'png',
      quality: 0.98
    },
    html2canvas: {
      dpi: 192,
      letterRendering: true,
      scale: 2,
      useCORS: true
    },
    jsPDF: {
      unit: 'in',
      format: 'a4',
      orientation: 'portrait'
    }
  }).then(() => {
    if (callback) {
      callback()
    }
  })
}

export function enumsMap(code: null | undefined, objArr: { filter: (arg0: (item: any) => boolean) => any[]; }) {
  let str = ''
  if (code === undefined || code === null || !objArr) {
    // str = ''
  } else {
    let match = objArr.filter(item => {
      return item.code === code
    })[0]
    str = match ? match.description : ''
  }
  return str
}

// Obj 转地址栏参数
export function objToQueryStr(obj:any) {
  let str = ''
  for (let key in obj) {
    str += `${key}=${encodeURIComponent(obj[key])}&`
  }
  return str
}

// 字符串截取
export function substring(string:string, length: number, mark: string = '...') {
  let str = string
  if (str.length > length) {
    str = str.substring(0, 5) + '...'
  }
  return str
}

export default {
  setVal,
  parsePrice,
  deepClone,
  randomString,
  toBase64,
  isDetail,
  hasPermission,
  resetObject,
  parseTime,
  savePdf,
  enumsMap,
  substring,
  objToQueryStr
}
